import { render, staticRenderFns } from "./qrCodeGodexPage.vue?vue&type=template&id=463b61db&scoped=true"
import script from "./qrCodeGodexPage.vue?vue&type=script&lang=js"
export * from "./qrCodeGodexPage.vue?vue&type=script&lang=js"
import style0 from "./qrCodeGodexPage.vue?vue&type=style&index=0&id=463b61db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463b61db",
  null
  
)

export default component.exports